import axios from "@/api/axiosInstance";
import { GetMPDashboardRequest, GetMPDashboardResponse } from "./types";

export const getMPDashboard = async (
  requestData: GetMPDashboardRequest,
  signal?: AbortSignal,
): Promise<GetMPDashboardResponse> => {
  const response = await axios.get<GetMPDashboardResponse>(
    `/api/private/stochastic/market-presence-dashboard`,
    { params: requestData, signal },
  );

  return response.data;
};
